import { render, staticRenderFns } from "./preguntas-evento.vue?vue&type=template&id=9b432692&"
import script from "./preguntas-evento.vue?vue&type=script&lang=js&"
export * from "./preguntas-evento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports